import KaInfiniteLoader from '../KaInfiniteLoader/KaInfiniteLoader.vue';
// eslint-disable-next-line vue-component-file-name-match/match-component-import-name
import KaTableBase from './KaTable.vue';
import KaTableCell from './KaTableCell.vue';
import KaTableEmptyContainer from './KaTableEmptyContainer.vue';
import KaTableHeadCell from './KaTableHeadCell.vue';
import KaTableHeadRow from './KaTableHeadRow.vue';
import KaTableRow from './KaTableRow.vue';
import KaTableScrollWrapper from './KaTableScrollWrapper.vue';
import KaTableSelectCell from './KaTableSelectCell.vue';
import KaTableSelectHeaderCell from './KaTableSelectHeaderCell.vue';
import KaTableSkeletonRow from './KaTableSkeletonRow.vue';
import KaVirtualHorizontalScroll from './KaVirtualHorizontalScroll.vue';

export { useMaybeVirtualizedRows } from './useMaybeVirtualizedRows';

Object.assign(KaTableBase, {
  Cell: KaTableCell,
  EmptyContainer: KaTableEmptyContainer,
  HeadCell: KaTableHeadCell,
  HeadRow: KaTableHeadRow,
  Row: KaTableRow,
  ScrollWrapper: KaTableScrollWrapper,
  SelectCell: KaTableSelectCell,
  SelectHeaderCell: KaTableSelectHeaderCell,
  SkeletonRow: KaTableSkeletonRow,
  VirtualHorizontalScroll: KaVirtualHorizontalScroll,
  InfiniteLoader: KaInfiniteLoader,
});

export const KaTable = KaTableBase as typeof KaTableBase & {
  Cell: typeof KaTableCell;
  EmptyContainer: typeof KaTableEmptyContainer;
  HeadCell: typeof KaTableHeadCell;
  HeadRow: typeof KaTableHeadRow;
  Row: typeof KaTableRow;
  ScrollWrapper: typeof KaTableScrollWrapper;
  SelectCell: typeof KaTableSelectCell;
  SelectHeaderCell: typeof KaTableSelectHeaderCell;
  SkeletonRow: typeof KaTableSkeletonRow;
  VirtualHorizontalScroll: typeof KaVirtualHorizontalScroll;
  InfiniteLoader: typeof KaInfiniteLoader;
};

export {
  KaInfiniteLoader,
  KaTableCell,
  KaTableEmptyContainer,
  KaTableHeadCell,
  KaTableHeadRow,
  KaTableRow,
  KaTableScrollWrapper,
  KaTableSelectCell,
  KaTableSelectHeaderCell,
  KaTableSkeletonRow,
  KaVirtualHorizontalScroll,
};
